module.exports = __webpack_public_path__ + "assets/img/icon2.d2e57178.svg";